import { t } from "@galaxy-io/dls/theme/tokens/t";
import { styled } from "@linaria/react";

/**
 * The observability dashboards share one vocabulary: a scrolling column of
 * stat tiles, a two-column grid of bordered cards, a plot or a fixed-height
 * table inside each card. Kept here so the audience and website views read as
 * one screen rather than two.
 */
export const Dashboard = styled.div`
  flex: 1 1 0 !important;
  min-height: 0;
  overflow-y: auto;
  padding: ${t.space[16]} var(--gtm-page-inset, ${t.space[24]}) ${t.space[24]};
  display: flex;
  flex-direction: column;
  gap: ${t.space[12]};
  > * {
    flex-shrink: 0;
  }
`;
export const Grid = styled.div<{ $columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns ?? 2}, minmax(0, 1fr));
  gap: ${t.space[12]};
  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
/** A card title never wraps; the aside beside it gives way and truncates instead. */
export const CardTitle = styled.div`
  flex-shrink: 0;
  white-space: nowrap;
`;
export const Plot = styled.div`
  padding: ${t.space[12]} ${t.space[16]};
`;
export const TableBody = styled.div`
  height: 340px;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;
export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: ${t.space[12]};
`;
